/**
 * @name Notification
 * @description Componente notificación
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { Icons, Typography } from '@styles';

const Notification = (props) => {
  const { notification } = props;
  return (
    <Styled.NotificationWrapper>
      <Styled.NotificationContent onClick={() => props.onReadNotification(notification)}>
        <Styled.NotificationAppIcon
          src={notification.Logo}
          alt={notification.Aplicacion}
        />
        <Styled.NotificationBody>
          <Styled.AppText>
            {notification.Aplicacion}
          </Styled.AppText>
          <Styled.NotificationMessage>
            <Trans>{notification.MensajeNotificacion}</Trans>
          </Styled.NotificationMessage>
          <Styled.BoxTime>
            <Icons.Time />
            <Styled.TimeText>
              {notification.Tiempo}
            </Styled.TimeText>
          </Styled.BoxTime>
        </Styled.NotificationBody>
      </Styled.NotificationContent>
      <Styled.BoxClose onClick={() => props.onDeleteNotification(notification.Id)}>
        <Icons.Close />
      </Styled.BoxClose>
    </Styled.NotificationWrapper>
  );
};

Notification.propTypes = {
  // El objecto con la información de la notificación.
  notification: PropTypes.object.isRequired,
  // Función para leer y redireccionar la notificación.
  onReadNotification: PropTypes.func.isRequired,
  // Función para eliminar la notificación.
  onDeleteNotification: PropTypes.func.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.NotificationWrapper = styled.div`
  display: flex;
  width: 100%;
`;

Styled.NotificationContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

Styled.NotificationBody = styled.div`
  display: flex;
  flex-direction: column;
`;

Styled.NotificationAppIcon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  margin: 0 16px 0 8px;
`;

Styled.NotificationMessage = styled(Typography.Text)`
  word-break: break-word;
  line-height: 1.2;
`;

Styled.AppText = styled(Typography.Text)`
  font-family: 'Bryant Pro Medium';
  font-size: ${(props) => props.theme.typography.smallText};
`;

Styled.TimeText = styled(Typography.Text)`
  margin-top: 2.5px;
  margin-left: 5px;
  font-family: 'Bryant Pro Medium';
  font-size: 10px;
`;

Styled.BoxTime = styled.div`
  display: flex;
  align-items: center;

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

Styled.BoxClose = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  width: 18px;

  .MuiSvgIcon-root {
    font-size: 14px;
    &:hover {
      font-size: 18px;
    }
  }
`;

export default Notification;
